/* tslint:disable */
/* eslint-disable */
/**
 * Y-Sports backend-next Management API
 * Composed management-facing contract for `backend-next`. This spec is an aggregation layer over module-scoped contracts and should reference canonical module definitions instead of copying them. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LegacyAdvancementRule
 */
export interface LegacyAdvancementRule {
    /**
     * 
     * @type {string}
     * @memberof LegacyAdvancementRule
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof LegacyAdvancementRule
     */
    categoryId?: string;
    /**
     * 
     * @type {string}
     * @memberof LegacyAdvancementRule
     */
    sourceStageId?: string;
    /**
     * 
     * @type {string}
     * @memberof LegacyAdvancementRule
     */
    sourceGroupId?: string;
    /**
     * 
     * @type {number}
     * @memberof LegacyAdvancementRule
     */
    sourcePosition?: number;
    /**
     * 
     * @type {string}
     * @memberof LegacyAdvancementRule
     */
    targetSlotId?: string;
    /**
     * 
     * @type {string}
     * @memberof LegacyAdvancementRule
     */
    label?: string;
}

/**
 * Check if a given object implements the LegacyAdvancementRule interface.
 */
export function instanceOfLegacyAdvancementRule(value: object): value is LegacyAdvancementRule {
    return true;
}

export function LegacyAdvancementRuleFromJSON(json: any): LegacyAdvancementRule {
    return LegacyAdvancementRuleFromJSONTyped(json, false);
}

export function LegacyAdvancementRuleFromJSONTyped(json: any, ignoreDiscriminator: boolean): LegacyAdvancementRule {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'categoryId': json['categoryId'] == null ? undefined : json['categoryId'],
        'sourceStageId': json['sourceStageId'] == null ? undefined : json['sourceStageId'],
        'sourceGroupId': json['sourceGroupId'] == null ? undefined : json['sourceGroupId'],
        'sourcePosition': json['sourcePosition'] == null ? undefined : json['sourcePosition'],
        'targetSlotId': json['targetSlotId'] == null ? undefined : json['targetSlotId'],
        'label': json['label'] == null ? undefined : json['label'],
    };
}

export function LegacyAdvancementRuleToJSON(json: any): LegacyAdvancementRule {
    return LegacyAdvancementRuleToJSONTyped(json, false);
}

export function LegacyAdvancementRuleToJSONTyped(value?: LegacyAdvancementRule | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'categoryId': value['categoryId'],
        'sourceStageId': value['sourceStageId'],
        'sourceGroupId': value['sourceGroupId'],
        'sourcePosition': value['sourcePosition'],
        'targetSlotId': value['targetSlotId'],
        'label': value['label'],
    };
}

